// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab-module--tab--K4vw8","active":"Tab-module--active--10UqU"};